import { FEATURE_FLAGS, isFeatureEnabled } from '../utils/featureFlag';

const enumToArray = (obj) => Object.values(obj).filter((value) => typeof value !== 'function');

export const FUEL_TYPE = [
  {
    value: 'gas',
    label: 'Gas'
  },
  {
    value: 'hybrid',
    label: 'Hybrid'
  },
  {
    value: 'electric',
    label: 'Electric'
  }
];

export const CONTENT_TYPE = {
  MSLP: {
    value: 'mslp',
    label: 'Model Specific Landing Page (MSLP)',
    shortLabel: 'MSLP'
  },
  INVENTORY: {
    value: 'inventory',
    label: 'Inventory'
  },
  BLOG: {
    value: 'blog',
    label: 'Blog Post'
  },
  OTHER: {
    value: 'other',
    label: 'Other'
  },
  toArray: () =>
    enumToArray(CONTENT_TYPE).filter(
      (entry) => isFeatureEnabled(FEATURE_FLAGS.INVENTORY_PAGE) || entry.label !== 'Inventory'
    )
};

export const HISTORY_PERIOD = {
  Today: 'Today',
  Yesterday: 'Yesterday',
  ThisMonth: 'This Month',
  Older: 'Older'
};
